import { render, staticRenderFns } from "./NewFnbOwner.vue?vue&type=template&id=6eedc4a0&"
import script from "./NewFnbOwner.vue?vue&type=script&lang=ts&"
export * from "./NewFnbOwner.vue?vue&type=script&lang=ts&"
import style0 from "./NewFnbOwner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports